import { useNavigate, useParams } from 'react-router-dom';
import { useEntityTypes } from '../hooks/useApi';
import {
  FaSyringe,
  FaPills,
  FaHeartbeat,
  FaFirstAid,
  FaDisease,
  FaLeaf,
  FaVial
} from 'react-icons/fa';

const ENTITY_ICONS = {
  'Medical Procedure': FaSyringe,
  'Prescription Medication': FaPills,
  'Symptom': FaHeartbeat,
  'OTC Medication': FaFirstAid,
  'Condition': FaDisease,
  'Natural Supplement': FaLeaf,
  'Medical Test': FaVial,
};

function Sidebar() {
  const navigate = useNavigate();
  const { type: selectedType } = useParams();
  const { data: entityTypes, isLoading, error } = useEntityTypes();

  if (isLoading) {
    return (
      <div className="bg-white p-4 rounded-lg shadow">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mt-2"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3 mt-2"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white p-4 rounded-lg shadow">
        <p className="text-red-500">Error loading entity types. Please try again.</p>
      </div>
    );
  }

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <div className="space-y-2">
        {entityTypes.map(type => {
          const Icon = ENTITY_ICONS[type] || FaFirstAid;
          return (
            <button
              key={type}
              className={`w-full text-left px-3 py-2 rounded hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center gap-2 ${
                selectedType === type ? 'bg-blue-50 text-blue-700' : ''
              }`}
              onClick={() => navigate(`/type/${encodeURIComponent(type)}`)}
            >
              <Icon className="flex-shrink-0 w-4 h-4" />
              <span>{type}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default Sidebar;